let couponShow = false;
const couponBtn = () => {
  const cv = document.querySelectorAll(".coupon .vmore");
  const cc = document.querySelector(".coupon .c-c");
  const cl = document.querySelector("#close");

  cl.addEventListener("click", () => {
    couponShow = false;
    cc.style.display = "none";
  });
  cv.forEach((i) => {
    i.addEventListener("click", () => {
      couponShow = !couponShow;
      if (couponShow) {
        cc.style.display = "block";
      } else {
        cc.style.display = "none";
      }
    });
  });
};

couponBtn();

let processCoupon = () => {
  const cp = document.querySelector("#coupon");
  const cb = document.querySelector("#couponBox");
  const ccb = document.querySelector("#contentCouponBox");
  const c = JSON.parse(document.getElementById("couponList").innerHTML);
  const d = [];

  c.forEach((i) => {
    if (i.indexOf("coupon:") !== -1) {
      d.push(i.replace("coupon:", ""));
    }
  });

  d.forEach((item, index) => {
    if (index < 3) {
      const sdiv = document.createElement("div");
      sdiv.className = "c";
      const sp = document.createElement("span");
      sp.innerText = item;
      sdiv.appendChild(sp);
      const cc = document.querySelector(".coupon .c-div .v");
      cb.insertBefore(sdiv, cc);
    }

    const sd = document.createElement("div");
    const sdi = document.createElement("i");
    const sdimg = document.createElement("img");
    const sdspan = document.createElement("span");
    sdimg.src = "{{ 'coupon.webp' | asset_url }}";
    sdspan.innerText = item;
    sdi.appendChild(sdimg);
    sd.appendChild(sdi);
    sd.appendChild(sdspan);
    ccb.appendChild(sd);
  });
  if (!d.length) {
    cp.style.display = "none";
  }
  if (d.length < 3) {
    const cdv = document.querySelector(".c-div .v");
    cdv.style.display = "none";
  } else {
    const cdv = document.querySelector(".c-div .v");
    cdv.style.display = "block";
  }
};
processCoupon();
// document.addEventListener("shopify:section:load", processCoupon);
